import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerNew: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F3F7F7',
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    marginHorizontal: 32,
  },
  content: {
    width: '80%',
    maxWidth: 396,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 24,
  },
  content_mobile: {
    width: '80%',
    maxWidth: 396,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title_mobile: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 24,
    textAlign: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    lineHeight: 30,
    textAlign: 'center',
  },
  dropzoneArea: {
    borderRadius: 20,
    borderWidth: 3,
    borderStyle: 'dashed',
    borderColor: brand.main.variations['lighterWater-2'],
  },
  dropzone: {
    justifyContent: 'center',
    width: '100%',
    alignItems: 'center',
    paddingVertical: 24,
    paddingHorizontal: 40,
    gap: 24,
  },
  dropzoneText_mobile: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: 400,
    textAlign: 'center',
  },
  dropzoneText: {
    color: neutrals.neutralGrays.graphite,
    fontSize: 16,
    lineHeight: 22,
    fontWeight: 400,
    textAlign: 'center',
  },
  button: {
    backgroundColor: brand.main.water,
    borderRadius: 100,
    paddingVertical: 9,
    paddingHorizontal: 18,
    height: 40,
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4, // Android only
  },
  button_mobile: {
    backgroundColor: brand.main.water,
    borderRadius: 100,
    paddingVertical: 9,
    paddingHorizontal: 18,
    height: 50,
    shadowColor: neutrals.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4, // Android only
    width: 295,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 22,
  },
  otherOptionsContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  otherOptionsText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 18,
    letterSpacing: 0.16,
    textAlign: 'center',
  },
  otherOptionsTextMobile: {
    fontSize: 16,
    lineHeight: 22,
  },
  otherOptionsButton: {
    color: brand.main.water,
    fontSize: 14,
    lineHeight: 18,
    fontWeight: 700,
    letterSpacing: 0.16,
  },
  goToSiteContainer: {
    borderWidth: 2,
    borderColor: 'transparent',
  },
  goToSiteContainerFocus: {
    borderColor: FOCUS_COLOR,
  },
  goToSiteInnerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    gap: 4,
    borderWidth: 0,
    ...getBoxShadow('none'),
    backgroundColor: 'transparent',
    minHeight: 'auto',
    padding: 0,
    margin: 0,
  },
  icon: {
    width: 12,
    height: 12,
    color: brand.main.water,
  },
});
